import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import * as moment from 'moment';
import { MatDialog } from '@angular/material';

import { AlertComponent } from '../alert/alert.component';
import { environment } from 'src/environments/environment';
import { FileUploadService } from 'src/services/file-upload.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { MessageService } from 'src/services/message.service';
import { Utils } from 'src/services/utils';
@Component({
  selector: 'rm-epics-new-import',
  templateUrl: './epics-new-import.component.html',
  styleUrls: ['./epics-new-import.component.css']
})
export class EpicsNewImportComponent implements OnInit {

  gcp: string;
  uploader;
  attachment: any;
  fileUploaded: boolean = false;
  batchesData: any[];
  @ViewChild('importBtnRef', {static: false}) fileImportBtnRef: ElementRef;
  tempUploadedFileData: any;
  showNoBatchesPart: boolean = false;

  constructor(
    private uploadService: FileUploadService,
    private globalCfgService: GlobalCfgService,
    private msgService: MessageService,
    private dialog: MatDialog,
    private utils: Utils,
  ) { }

  ngOnInit() {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }
    this.uploader = this.uploadService.getUploader(environment.epcisfilesContainer);
  }

  onFileSelected() {
    this.uploader.response.subscribe(
      response => {
        this.attachment = JSON.parse(response)["result"]["files"]["file"][0];
        this.fileImportBtnRef.nativeElement.value = "";
        // console.log(this.fileImportBtnRef.nativeElement.files);
        this.initiateEpcisUpload(this.attachment);
      },
      error => {
        console.log("File upload error:", error);
      }
    );
  }

  initiateEpcisUpload(attachment) {
    let toSetDate = this.setCurrentDateWithDayStartTime();
    // let path = this.attachment.providerResponse.location;

    let rec = {
      gcp: this.gcp,
      file: attachment.name,
      folder: attachment.container,
      mfgDate: moment(toSetDate).utc().format(),
      eventTimeZoneOffset: this.utils.getTimeZoneFromDateString(moment(toSetDate).format())
    }
    this.uploadService.epcisFileUpload(rec).subscribe((response: any) => {
      this.batchesData = response.batches;
      this.setBatchesIdxAndExpDateFormat();
      this.tempUploadedFileData = response.rec;
      // console.log('data',this.uploaddata);
      if (this.batchesData.length > 0) {
        this.fileUploaded = true;
        if (this.showNoBatchesPart === true) {
          this.showNoBatchesPart = false;
        }
      } else if (this.batchesData.length === 0) {
        this.showNoBatchesPart = true;
      }
      // this.NotificationsService.showSuccess('segmnt created successfully!');
    },error => {
      console.log("Service error:", error);
    });
  }

  // returns moment date string with current system date and day start (12 am) time 
  setCurrentDateWithDayStartTime() {
    let toSetDate = moment(Date.now());
    toSetDate.set({hour:0,minute:0,second:0,millisecond:0}).toISOString()
    toSetDate.format();
    // console.log(toSetDate);
    return toSetDate;
  }

  
  // set exp date format for display
  setBatchesIdxAndExpDateFormat() {
    this.batchesData.forEach((batch, index: number) => {
      batch.expDateFormatted = moment(batch.expiryDate).format('DD/MM/YYYY');
    });
  }

  toSetBatchMfgDate(event, setOnBatch) {
    // console.log(event, setOnBatch);
    const addedBatchMfgDate = this.setServerFormatBatchMfgDate(event);
    const editedBatchIndex = this.batchesData.findIndex(b => {
      return b.batchNo === setOnBatch.batchNo;
    });
    if (editedBatchIndex > -1) {
      this.batchesData[editedBatchIndex].newMfgDate = addedBatchMfgDate.mfgDt;
      this.batchesData[editedBatchIndex].newMfgTimeZone = addedBatchMfgDate.mfgTimeZone;
    }
  }

  // selecting MFG DATE
  setServerFormatBatchMfgDate(selectedMfgDate) {
    return {
      mfgDt: moment(selectedMfgDate).utc().format(),
      mfgTimeZone: this.utils.getTimeZoneFromDateString(moment(selectedMfgDate).format())
    };
  }

  // check if dates are set by user for each batch and 
  // then send data to save
  checkProcessUpload() {
    let checkData = this.batchMfgDateUserSetCheck(this.batchesData);

    if (checkData['batchDateNotSetCheck'] === true) {
      // console.log("show dialog for date not set for a batch");
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: { 
          title: "Import",
          note: "Set Mfg date for each  batch to continue import",
        },
      })
    } else {
      this.processUpload(this.batchesData, this.tempUploadedFileData);
    }
  }

  //check If Any Batch MfgDate Not Set and 
  //return true or false
  batchMfgDateUserSetCheck(batchesData) {
    let checkData: {
      batchDateNotSetCheck: boolean,
      batchIndex: Number
    } = {
      batchDateNotSetCheck: true,
      batchIndex: -1
    };

    batchesData.forEach((batch, index) => {
      if (batch.newMfgDate === undefined) {
        checkData.batchDateNotSetCheck = true;
        checkData.batchIndex = index;
      }
    });

    if (checkData.batchIndex === -1) {
      checkData.batchDateNotSetCheck = false;
    }

    return checkData;
  }

  // send data to complete import
  processUpload(batchesData, tempFileData) {
    const rec = {
      batchesData: batchesData,
      uploadedFileData: tempFileData
    }

    this.uploadService.processFileUpload(rec).subscribe(response => {
      this.clearUploadData();
      this.msgService.showSuccess(response["message"]);
      // alert(response["message"]);
    },error => {
      console.log("Service error:", error);
    });
  }

  // clear and reset
  clearUploadData() {
    this.fileUploaded = false;
    this.batchesData = [];
    this.attachment = undefined;
    this.tempUploadedFileData = undefined;
  }
}
